export default {
    generateContentModal: {
        title: 'Generate Content',
        type: 'Type',
        typePlaceholder: 'Select type',
        typeEmptyError: 'Please select the type',
        context: 'Context',
        contextPlaceholder: 'Select context',
        contextEmptyError: 'Please select the context',
        contentTitle: 'Content title',
        contentTitlePlaceholder: 'Add the theme of your content',
        contentTitleEmptyError: 'Please enter the title',
        contentTitleInvalidError: 'Please enter the valid title',
        contentTitleNumberError: 'Please enter a title that begins with a letter',
        description: 'Provide a brief content description',
        descriptionPlaceholder: 'Add the description of your content in 2-3 lines',
        descriptionEmptyError: 'Please enter the description',
        descriptionInvalidError: 'Please enter the valid description',
        addKeywords: 'Add keywords',
        addKeywordsEmptyError: 'Please enter the keywords',
        writingTone: 'Writing Tone',
        writingTonePlaceholder: 'Select writing tone',
        writingToneEmptyError: 'Please select the writing tone',
        numberOfVariations: 'Number of variations',
        numberOfVariationsEmptyError: 'Please select the number of variation',
        numberOfVariationsInvalidError: 'You can generate maximum 5 and minimum 1 variation.',
        generate: 'Generate',
        additionalOptions: 'Additional options',
        clear: 'Clear',
        writingToneOptions: {
            funny: 'Funny',
            casual: 'Casual',
            excited: 'Excited',
            professional: 'Professional',
            witty: 'Witty',
            sarcastic: 'Sarcastic',
            feminine: 'Feminine',
            masculine: 'Masculine',
            bold: 'Bold',
            dramatic: 'Dramatic',
            grumpy: 'Grumpy',
            secretive: 'Secretive',
            respectful: 'Respectful',
            persuasive: 'Persuasive',
        },
        contextOptions: {
            promotional: 'Promotional',
            introduction: 'Introduction',
            couponDiscount: 'Coupon/Discount',
            recurringNewsletter: 'Recurring Newsletter',
            testimonial: 'Testimonial',
            coldOutreach: 'Cold Outreach',
            contentGiveaway: 'Content/Giveaway',
            other: 'Other',
        },
        typeOptions: {
            outline: 'Outline',
            introduction: 'Introduction',
            section: 'Section',
        },
        customLengthOfContentPlaceholder: 'Number of words (max 900)',
        lengthOfContentPlaceholder: 'Select content length',
        lengthOfContent: 'Length of the content',
        customLengthOfContent: 'Custom Length',
        smallContent: 'Small',
        mediumContent: 'Medium',
        largeContent: 'Large',
        customContentLength: 'Custom Length (50 - 900 words)',
        lengthOfContentError: 'Please select the length of content',
        customLengthError: 'Incorrect value',
        lengthOfContentTooltip: 'Set the length of content which will be generated based on the prompts description.',
    },
};
